import { jsx as _jsx } from "react/jsx-runtime";
import Sidebar from "@components/sidebar/Sidebar";
const CareerSidebar = (props) => {
    return (_jsx("div", { className: "career-sidebar__wrapper", children: _jsx(Sidebar, { ...props }) }));
};
export default CareerSidebar;
